export default __webpack_public_path__ + "static/media/table-tennis.0b03d79c.png";